<template>
	<div
		class="form-field--wrapper"
		:class="classes"
	>
		<label
			v-if="label"
			class="form-field--label"
			:class="labelClass"
		>
			{{ label }}
			<div
				v-if="info"
				v-tooltip="{content: info, classes: 'tooltip'}"
				class="form-field--info"
			>
				<Icon
					icon-name="c-info"
					size="sm"
				/>
			</div>
		</label>
		<div class="form-field--input-wrapper">
			<!-- form field slot -->
			<slot />
			<!-- end form field slot -->
		</div>
		<div
			v-if="error"
			class="form-field--error-wrapper"
		>
			<Icon
				icon-name="c-warning"
				size="xs"
			/>
			<span
				class="error-label-text"
			>
				{{ error }}
			</span>
		</div>
	</div>
</template>
<script>
export default {
	name:  'FormField',
	props: {
		classes: {
			type:    [Object, Array],
			default: () => ({}),
		},
		labelClass: {
			type:    [Object, Array],
			default: () => ({}),
		},
		error: {
			type:    String,
			default: null,
		},
		label: {
			type:    String,
			default: null,
		},
		info: {
			type:    String,
			default: null,
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@shared/sass/shared-variables';
@import '@videotools/sass/_fonts';

.form-field--label,
.form-field--input-wrapper {
	margin-bottom: 6px;
}

.form-field--label {
	@extend .text-sm;
	color: var(--color-grey-300);
	display: flex;
	align-items: center;
}

.form-field--info {
	margin-left: auto;
}

.form-field--error-wrapper {
	color: var(--color-red);
	font-size: 14px;
	line-height: 20px;
	display: flex;
	align-items: center;

	.error-label-text {
		margin-left: 8px;
	}
}

</style>
